export default __webpack_public_path__ + "static/media/Ocelots_Still_1.4f715e44.jpg";